// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import {
  changeEmailResponseTransformer,
  completeRegistrationResponseTransformer,
  createBookingSessionResponseTransformer,
  getBookableResponseTransformer,
  getBookingPriceSummaryResponseTransformer,
  getBookingSessionResponseTransformer,
  getDevicesResponseTransformer,
  getInvoicesResponseTransformer,
  getOrderHistoryResponseTransformer,
  getPriceBreakdownResponseTransformer,
  getSubscriptionResponseTransformer,
  getUserResponseTransformer,
  linkAppleIdentityResponseTransformer,
  listOrdersResponseTransformer,
  updatePersonalDataResponseTransformer,
} from './transformers.gen';
import type {
  ActivationActivateData,
  ActivationActivateErrors,
  ActivationActivateResponses,
  ActivationVerifyTokenData,
  ActivationVerifyTokenErrors,
  ActivationVerifyTokenResponses,
  AddFeedbackData,
  AddFeedbackErrors,
  AddFeedbackResponses,
  AmazonLoginData,
  AmazonLoginErrors,
  AmazonLoginResponses,
  AmazonRegisterData,
  AmazonRegisterErrors,
  AmazonRegisterResponses,
  AppleLoginData,
  AppleLoginErrors,
  AppleLoginResponses,
  AppleRegisterData,
  AppleRegisterErrors,
  AppleRegisterResponses,
  ApproveDeviceAuthorizationData,
  ApproveDeviceAuthorizationErrors,
  ApproveDeviceAuthorizationResponses,
  ChangeEmailData,
  ChangeEmailErrors,
  ChangeEmailResponses,
  ChangePasswordData,
  ChangePasswordErrors,
  ChangePasswordResponses,
  CompleteRegistrationData,
  CompleteRegistrationErrors,
  CompleteRegistrationResponses,
  CreateBookingSessionData,
  CreateBookingSessionErrors,
  CreateBookingSessionResponses,
  CreateParentalControlsVerificationData,
  CreateParentalControlsVerificationErrors,
  CreateParentalControlsVerificationResponses,
  DeleteParentalControlsVerificationData,
  DeleteParentalControlsVerificationErrors,
  DeleteParentalControlsVerificationResponses,
  DeletePaymentBearerData,
  DeletePaymentBearerErrors,
  DeletePaymentBearerResponses,
  DownloadInvoicePdfData,
  DownloadInvoicePdfErrors,
  DownloadInvoicePdfResponses,
  EmailCheckData,
  EmailCheckErrors,
  EmailCheckResponses,
  GetBookableData,
  GetBookableErrors,
  GetBookableResponses,
  GetBookingPriceSummaryData,
  GetBookingPriceSummaryErrors,
  GetBookingPriceSummaryResponses,
  GetBookingSessionData,
  GetBookingSessionErrors,
  GetBookingSessionResponses,
  GetCommunicationPreferencesData,
  GetCommunicationPreferencesErrors,
  GetCommunicationPreferencesResponses,
  GetDeviceAuthorizationData,
  GetDeviceAuthorizationErrors,
  GetDeviceAuthorizationResponses,
  GetDevicesData,
  GetDevicesErrors,
  GetDevicesResponses,
  GetHardwareProductsData,
  GetHardwareProductsErrors,
  GetHardwareProductsResponses,
  GetHomeZoneStatusData,
  GetHomeZoneStatusErrors,
  GetHomeZoneStatusResponses,
  GetInvoicesData,
  GetInvoicesErrors,
  GetInvoicesResponses,
  GetOrderHistoryData,
  GetOrderHistoryErrors,
  GetOrderHistoryResponses,
  GetParentalControlsVerificationData,
  GetParentalControlsVerificationErrors,
  GetParentalControlsVerificationResponses,
  GetPaymentBearerData,
  GetPaymentBearerErrors,
  GetPaymentBearerResponses,
  GetPermissionsData,
  GetPermissionsErrors,
  GetPermissionsResponses,
  GetPriceBreakdownData,
  GetPriceBreakdownErrors,
  GetPriceBreakdownResponses,
  GetRecentlyWatchedData,
  GetRecentlyWatchedErrors,
  GetRecentlyWatchedResponses,
  GetReturnLabelData,
  GetReturnLabelErrors,
  GetReturnLabelResponses,
  GetSelfServiceTokenData,
  GetSelfServiceTokenErrors,
  GetSelfServiceTokenResponses,
  GetSessionData,
  GetSessionErrors,
  GetSessionResponses,
  GetSubscriptionCapabilitiesData,
  GetSubscriptionCapabilitiesErrors,
  GetSubscriptionCapabilitiesResponses,
  GetSubscriptionData,
  GetSubscriptionErrors,
  GetSubscriptionResponses,
  GetSummaryData,
  GetSummaryErrors,
  GetSummaryResponses,
  GetUserData,
  GetUserErrors,
  GetUserResponses,
  GoogleLoginData,
  GoogleLoginErrors,
  GoogleLoginResponses,
  GoogleRegisterData,
  GoogleRegisterErrors,
  GoogleRegisterResponses,
  LinkAppleIdentityData,
  LinkAppleIdentityErrors,
  LinkAppleIdentityResponses,
  ListOrdersData,
  ListOrdersErrors,
  ListOrdersResponses,
  LogoutData,
  LogoutErrors,
  LogoutResponses,
  PasswordBreachCheckData,
  PasswordBreachCheckErrors,
  PasswordBreachCheckResponses,
  PasswordResetConfirmData,
  PasswordResetConfirmErrors,
  PasswordResetConfirmResponses,
  PasswordResetRequestData,
  PasswordResetRequestErrors,
  PasswordResetRequestResponses,
  PasswordResetVerifyData,
  PasswordResetVerifyErrors,
  PasswordResetVerifyResponses,
  ReAuthenticateData,
  ReAuthenticateErrors,
  ReAuthenticateResponses,
  RedeemFunkeOfferData,
  RedeemFunkeOfferErrors,
  RedeemFunkeOfferResponses,
  RefreshSessionData,
  RefreshSessionErrors,
  RefreshSessionResponses,
  RegistrationLocationEligibilityData,
  RegistrationLocationEligibilityErrors,
  RegistrationLocationEligibilityResponses,
  RegistrationRegisterData,
  RegistrationRegisterErrors,
  RegistrationRegisterResponses,
  RemoveAllDevicesData,
  RemoveAllDevicesErrors,
  RemoveAllDevicesResponses,
  RemoveDeviceData,
  RemoveDeviceErrors,
  RemoveDeviceResponses,
  RequestCancellationData,
  RequestCancellationErrors,
  RequestCancellationResponses,
  RequestWithdrawalData,
  RequestWithdrawalErrors,
  RequestWithdrawalResponses,
  ResendEmailConfirmationData,
  ResendEmailConfirmationErrors,
  ResendEmailConfirmationResponses,
  SetSepaPaymentData,
  SetSepaPaymentErrors,
  SetSepaPaymentResponses,
  StartItemReturnData,
  StartItemReturnErrors,
  StartItemReturnResponses,
  SwitchBookingProductData,
  SwitchBookingProductErrors,
  SwitchBookingProductResponses,
  UnsubscribeCommunicationPreferencesData,
  UnsubscribeCommunicationPreferencesErrors,
  UnsubscribeCommunicationPreferencesResponses,
  UpdateCommunicationPreferencesData,
  UpdateCommunicationPreferencesErrors,
  UpdateCommunicationPreferencesResponses,
  UpdateParentalControlsEnabledData,
  UpdateParentalControlsEnabledErrors,
  UpdateParentalControlsEnabledResponses,
  UpdateParentalControlsPinData,
  UpdateParentalControlsPinErrors,
  UpdateParentalControlsPinResponses,
  UpdatePersonalDataData,
  UpdatePersonalDataErrors,
  UpdatePersonalDataResponses,
  UpdateRecentlyWatchedData,
  UpdateRecentlyWatchedErrors,
  UpdateRecentlyWatchedResponses,
  VerifyEmailData,
  VerifyEmailErrors,
  VerifyEmailResponses,
} from './types.gen';
import {
  zActivationActivateResponse,
  zActivationVerifyTokenResponse,
  zAddFeedbackResponse,
  zAmazonLoginResponse,
  zAmazonRegisterResponse,
  zAppleLoginResponse,
  zAppleRegisterResponse,
  zApproveDeviceAuthorizationResponse,
  zChangeEmailResponse,
  zChangePasswordResponse,
  zCompleteRegistrationResponse,
  zCreateBookingSessionResponse,
  zCreateParentalControlsVerificationResponse,
  zDeleteParentalControlsVerificationResponse,
  zDeletePaymentBearerResponse,
  zEmailCheckResponse,
  zGetBookableResponse,
  zGetBookingPriceSummaryResponse,
  zGetBookingSessionResponse,
  zGetCommunicationPreferencesResponse,
  zGetDeviceAuthorizationResponse,
  zGetDevicesResponse,
  zGetHardwareProductsResponse,
  zGetHomeZoneStatusResponse,
  zGetInvoicesResponse,
  zGetOrderHistoryResponse,
  zGetParentalControlsVerificationResponse,
  zGetPaymentBearerResponse,
  zGetPermissionsResponse,
  zGetPriceBreakdownResponse,
  zGetRecentlyWatchedResponse,
  zGetSelfServiceTokenResponse,
  zGetSessionResponse,
  zGetSubscriptionCapabilitiesResponse,
  zGetSubscriptionResponse,
  zGetSummaryResponse,
  zGetUserResponse,
  zGoogleLoginResponse,
  zGoogleRegisterResponse,
  zLinkAppleIdentityResponse,
  zListOrdersResponse,
  zLogoutResponse,
  zPasswordBreachCheckResponse,
  zPasswordResetConfirmResponse,
  zPasswordResetRequestResponse2,
  zPasswordResetVerifyResponse,
  zReAuthenticateResponse,
  zRedeemFunkeOfferResponse,
  zRefreshSessionResponse,
  zRegistrationLocationEligibilityResponse,
  zRegistrationRegisterResponse,
  zRemoveAllDevicesResponse,
  zRemoveDeviceResponse,
  zRequestCancellationResponse,
  zRequestWithdrawalResponse,
  zSetSepaPaymentResponse,
  zStartItemReturnResponse,
  zSwitchBookingProductResponse,
  zUnsubscribeCommunicationPreferencesResponse,
  zUpdateCommunicationPreferencesResponse,
  zUpdateParentalControlsEnabledResponse,
  zUpdateParentalControlsPinResponse,
  zUpdatePersonalDataResponse,
  zUpdateRecentlyWatchedResponse,
  zVerifyEmailResponse,
} from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<
  TData,
  ThrowOnError,
  TResponse
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const amazonLogin = <ThrowOnError extends boolean = false>(
  options: Options<AmazonLoginData, ThrowOnError>,
): RequestResult<AmazonLoginResponses, AmazonLoginErrors, ThrowOnError> =>
  (options.client ?? client).post<AmazonLoginResponses, AmazonLoginErrors, ThrowOnError>({
    responseValidator: async (data) => await zAmazonLoginResponse.parseAsync(data),
    url: '/api/auth/amazon',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Register an Amazon SSO identity and establish a session.
 */
export const amazonRegister = <ThrowOnError extends boolean = false>(
  options: Options<AmazonRegisterData, ThrowOnError>,
): RequestResult<AmazonRegisterResponses, AmazonRegisterErrors, ThrowOnError> =>
  (options.client ?? client).post<AmazonRegisterResponses, AmazonRegisterErrors, ThrowOnError>({
    responseValidator: async (data) => await zAmazonRegisterResponse.parseAsync(data),
    url: '/api/auth/amazon/register',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const appleLogin = <ThrowOnError extends boolean = false>(
  options: Options<AppleLoginData, ThrowOnError>,
): RequestResult<AppleLoginResponses, AppleLoginErrors, ThrowOnError> =>
  (options.client ?? client).post<AppleLoginResponses, AppleLoginErrors, ThrowOnError>({
    responseValidator: async (data) => await zAppleLoginResponse.parseAsync(data),
    url: '/api/auth/apple',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Register an Apple SSO identity and establish a session.
 */
export const appleRegister = <ThrowOnError extends boolean = false>(
  options: Options<AppleRegisterData, ThrowOnError>,
): RequestResult<AppleRegisterResponses, AppleRegisterErrors, ThrowOnError> =>
  (options.client ?? client).post<AppleRegisterResponses, AppleRegisterErrors, ThrowOnError>({
    responseValidator: async (data) => await zAppleRegisterResponse.parseAsync(data),
    url: '/api/auth/apple/register',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Read the state of a device-flow user code
 *
 * Returns the verification state of the user code a device is displaying, plus the
 * device name the auth-service derived from that device's user agent. Unknown and expired codes are a
 * 200 carrying NOT_EXISTING / EXPIRED, so a caller can name the reason instead of showing a generic
 * failure.
 */
export const getDeviceAuthorization = <ThrowOnError extends boolean = false>(
  options: Options<GetDeviceAuthorizationData, ThrowOnError>,
): RequestResult<GetDeviceAuthorizationResponses, GetDeviceAuthorizationErrors, ThrowOnError> =>
  (options.client ?? client).get<GetDeviceAuthorizationResponses, GetDeviceAuthorizationErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetDeviceAuthorizationResponse.parseAsync(data),
    url: '/api/auth/device-authorization/{user-code}',
    ...options,
  });

/**
 * Approve or deny a device-flow user code
 *
 * Binds the signed-in account to the device that requested this user code; the
 * device receives its tokens on its next poll. Only a code in PENDING state can be decided.
 */
export const approveDeviceAuthorization = <ThrowOnError extends boolean = false>(
  options: Options<ApproveDeviceAuthorizationData, ThrowOnError>,
): RequestResult<ApproveDeviceAuthorizationResponses, ApproveDeviceAuthorizationErrors, ThrowOnError> =>
  (options.client ?? client).put<ApproveDeviceAuthorizationResponses, ApproveDeviceAuthorizationErrors, ThrowOnError>({
    responseValidator: async (data) => await zApproveDeviceAuthorizationResponse.parseAsync(data),
    url: '/api/auth/device-authorization/{user-code}/approval',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const googleLogin = <ThrowOnError extends boolean = false>(
  options: Options<GoogleLoginData, ThrowOnError>,
): RequestResult<GoogleLoginResponses, GoogleLoginErrors, ThrowOnError> =>
  (options.client ?? client).post<GoogleLoginResponses, GoogleLoginErrors, ThrowOnError>({
    responseValidator: async (data) => await zGoogleLoginResponse.parseAsync(data),
    url: '/api/auth/google',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Register a Google SSO identity and establish a session.
 */
export const googleRegister = <ThrowOnError extends boolean = false>(
  options: Options<GoogleRegisterData, ThrowOnError>,
): RequestResult<GoogleRegisterResponses, GoogleRegisterErrors, ThrowOnError> =>
  (options.client ?? client).post<GoogleRegisterResponses, GoogleRegisterErrors, ThrowOnError>({
    responseValidator: async (data) => await zGoogleRegisterResponse.parseAsync(data),
    url: '/api/auth/google/register',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
): RequestResult<LogoutResponses, LogoutErrors, ThrowOnError> =>
  (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    responseValidator: async (data) => await zLogoutResponse.parseAsync(data),
    url: '/api/auth/logout',
    ...options,
  });

/**
 * Check whether passwords with the given SHA-1 prefix appear in known breaches
 *
 * Returns the list of SHA-1 suffix + breach count pairs for the given 5-char hex prefix.
 * Implements k-anonymity: clients send only the first 5 chars of a SHA-1 password hash,
 * so the full password never leaves the browser.
 */
export const passwordBreachCheck = <ThrowOnError extends boolean = false>(
  options: Options<PasswordBreachCheckData, ThrowOnError>,
): RequestResult<PasswordBreachCheckResponses, PasswordBreachCheckErrors, ThrowOnError> =>
  (options.client ?? client).get<PasswordBreachCheckResponses, PasswordBreachCheckErrors, ThrowOnError>({
    responseValidator: async (data) => await zPasswordBreachCheckResponse.parseAsync(data),
    url: '/api/auth/password-breach/{prefix}',
    ...options,
  });

/**
 * Set a new password using a valid reset token
 */
export const passwordResetConfirm = <ThrowOnError extends boolean = false>(
  options: Options<PasswordResetConfirmData, ThrowOnError>,
): RequestResult<PasswordResetConfirmResponses, PasswordResetConfirmErrors, ThrowOnError> =>
  (options.client ?? client).post<PasswordResetConfirmResponses, PasswordResetConfirmErrors, ThrowOnError>({
    responseValidator: async (data) => await zPasswordResetConfirmResponse.parseAsync(data),
    url: '/api/auth/password-reset/confirm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Request a password-reset email
 *
 * Always responds 202, regardless of whether the email is registered, so callers can't probe which addresses exist. Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the password_reset action.
 */
export const passwordResetRequest = <ThrowOnError extends boolean = false>(
  options: Options<PasswordResetRequestData, ThrowOnError>,
): RequestResult<PasswordResetRequestResponses, PasswordResetRequestErrors, ThrowOnError> =>
  (options.client ?? client).post<PasswordResetRequestResponses, PasswordResetRequestErrors, ThrowOnError>({
    responseValidator: async (data) => await zPasswordResetRequestResponse2.parseAsync(data),
    url: '/api/auth/password-reset/request',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Verify a password-reset token (pre-flight before showing the form)
 */
export const passwordResetVerify = <ThrowOnError extends boolean = false>(
  options: Options<PasswordResetVerifyData, ThrowOnError>,
): RequestResult<PasswordResetVerifyResponses, PasswordResetVerifyErrors, ThrowOnError> =>
  (options.client ?? client).post<PasswordResetVerifyResponses, PasswordResetVerifyErrors, ThrowOnError>({
    responseValidator: async (data) => await zPasswordResetVerifyResponse.parseAsync(data),
    url: '/api/auth/password-reset/verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Re-authenticate for step-up
 *
 * Verifies the user's password and returns a short-lived step-up token. Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the re_authenticate action.
 */
export const reAuthenticate = <ThrowOnError extends boolean = false>(
  options: Options<ReAuthenticateData, ThrowOnError>,
): RequestResult<ReAuthenticateResponses, ReAuthenticateErrors, ThrowOnError> =>
  (options.client ?? client).post<ReAuthenticateResponses, ReAuthenticateErrors, ThrowOnError>({
    responseValidator: async (data) => await zReAuthenticateResponse.parseAsync(data),
    url: '/api/auth/re-authenticate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const refreshSession = <ThrowOnError extends boolean = false>(
  options?: Options<RefreshSessionData, ThrowOnError>,
): RequestResult<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError> =>
  (options?.client ?? client).post<RefreshSessionResponses, RefreshSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zRefreshSessionResponse.parseAsync(data),
    url: '/api/auth/refresh-session',
    ...options,
  });

/**
 * Delete the parental controls verification (debug/reset)
 */
export const deleteParentalControlsVerification = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteParentalControlsVerificationData, ThrowOnError>,
): RequestResult<DeleteParentalControlsVerificationResponses, DeleteParentalControlsVerificationErrors, ThrowOnError> =>
  (options?.client ?? client).delete<DeleteParentalControlsVerificationResponses, DeleteParentalControlsVerificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteParentalControlsVerificationResponse.parseAsync(data),
    url: '/api/parental-controls',
    ...options,
  });

/**
 * Get parental controls verification status
 */
export const getParentalControlsVerification = <ThrowOnError extends boolean = false>(
  options?: Options<GetParentalControlsVerificationData, ThrowOnError>,
): RequestResult<GetParentalControlsVerificationResponses, GetParentalControlsVerificationErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetParentalControlsVerificationResponses, GetParentalControlsVerificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetParentalControlsVerificationResponse.parseAsync(data),
    url: '/api/parental-controls',
    ...options,
  });

/**
 * Verify ID card and set parental controls PIN
 */
export const createParentalControlsVerification = <ThrowOnError extends boolean = false>(
  options: Options<CreateParentalControlsVerificationData, ThrowOnError>,
): RequestResult<CreateParentalControlsVerificationResponses, CreateParentalControlsVerificationErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateParentalControlsVerificationResponses, CreateParentalControlsVerificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateParentalControlsVerificationResponse.parseAsync(data),
    url: '/api/parental-controls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Enable or disable the parental controls PIN
 */
export const updateParentalControlsEnabled = <ThrowOnError extends boolean = false>(
  options: Options<UpdateParentalControlsEnabledData, ThrowOnError>,
): RequestResult<UpdateParentalControlsEnabledResponses, UpdateParentalControlsEnabledErrors, ThrowOnError> =>
  (options.client ?? client).patch<UpdateParentalControlsEnabledResponses, UpdateParentalControlsEnabledErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateParentalControlsEnabledResponse.parseAsync(data),
    url: '/api/parental-controls/enabled',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Change the parental controls PIN
 */
export const updateParentalControlsPin = <ThrowOnError extends boolean = false>(
  options: Options<UpdateParentalControlsPinData, ThrowOnError>,
): RequestResult<UpdateParentalControlsPinResponses, UpdateParentalControlsPinErrors, ThrowOnError> =>
  (options.client ?? client).patch<UpdateParentalControlsPinResponses, UpdateParentalControlsPinErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateParentalControlsPinResponse.parseAsync(data),
    url: '/api/parental-controls/pin',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getSession = <ThrowOnError extends boolean = false>(
  options?: Options<GetSessionData, ThrowOnError>,
): RequestResult<GetSessionResponses, GetSessionErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetSessionResponses, GetSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetSessionResponse.parseAsync(data),
    url: '/api/user/me',
    ...options,
  });

/**
 * Activate a sales-token and establish a session
 *
 * Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the token_activation action.
 */
export const activationActivate = <ThrowOnError extends boolean = false>(
  options: Options<ActivationActivateData, ThrowOnError>,
): RequestResult<ActivationActivateResponses, ActivationActivateErrors, ThrowOnError> =>
  (options.client ?? client).post<ActivationActivateResponses, ActivationActivateErrors, ThrowOnError>({
    responseValidator: async (data) => await zActivationActivateResponse.parseAsync(data),
    url: '/api/v1/activations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Verify a sales-token (activation pre-flight)
 */
export const activationVerifyToken = <ThrowOnError extends boolean = false>(
  options: Options<ActivationVerifyTokenData, ThrowOnError>,
): RequestResult<ActivationVerifyTokenResponses, ActivationVerifyTokenErrors, ThrowOnError> =>
  (options.client ?? client).post<ActivationVerifyTokenResponses, ActivationVerifyTokenErrors, ThrowOnError>({
    responseValidator: async (data) => await zActivationVerifyTokenResponse.parseAsync(data),
    url: '/api/v1/activations/verifications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * invoices of the user
 */
export const getInvoices = <ThrowOnError extends boolean = false>(
  options?: Options<GetInvoicesData, ThrowOnError>,
): RequestResult<GetInvoicesResponses, GetInvoicesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetInvoicesResponses, GetInvoicesErrors, ThrowOnError>({
    responseTransformer: getInvoicesResponseTransformer,
    responseValidator: async (data) => await zGetInvoicesResponse.parseAsync(data),
    url: '/api/v1/billing/invoices',
    ...options,
  });

/**
 * streams a single invoice PDF; the token binds the link to the user
 */
export const downloadInvoicePdf = <ThrowOnError extends boolean = false>(
  options: Options<DownloadInvoicePdfData, ThrowOnError>,
): RequestResult<DownloadInvoicePdfResponses, DownloadInvoicePdfErrors, ThrowOnError> =>
  (options.client ?? client).get<DownloadInvoicePdfResponses, DownloadInvoicePdfErrors, ThrowOnError>({
    url: '/api/v1/billing/invoices/{id}/pdf',
    ...options,
  });

/**
 * removes the user's stored payment method; succeeds when none is stored
 */
export const deletePaymentBearer = <ThrowOnError extends boolean = false>(
  options?: Options<DeletePaymentBearerData, ThrowOnError>,
): RequestResult<DeletePaymentBearerResponses, DeletePaymentBearerErrors, ThrowOnError> =>
  (options?.client ?? client).delete<DeletePaymentBearerResponses, DeletePaymentBearerErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeletePaymentBearerResponse.parseAsync(data),
    url: '/api/v1/billing/payment/bearer',
    ...options,
  });

/**
 * the user's current payment method
 */
export const getPaymentBearer = <ThrowOnError extends boolean = false>(
  options?: Options<GetPaymentBearerData, ThrowOnError>,
): RequestResult<GetPaymentBearerResponses, GetPaymentBearerErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetPaymentBearerResponses, GetPaymentBearerErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetPaymentBearerResponse.parseAsync(data),
    url: '/api/v1/billing/payment/bearer',
    ...options,
  });

/**
 * Billwerk self-service token for the payment SDK
 */
export const getSelfServiceToken = <ThrowOnError extends boolean = false>(
  options?: Options<GetSelfServiceTokenData, ThrowOnError>,
): RequestResult<GetSelfServiceTokenResponses, GetSelfServiceTokenErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetSelfServiceTokenResponses, GetSelfServiceTokenErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetSelfServiceTokenResponse.parseAsync(data),
    url: '/api/v1/billing/payment/self-service-token',
    ...options,
  });

/**
 * Change the payment method to SEPA direct debit
 *
 * Proxies to customer-self-care, which runs the Schufa credit check and writes the SEPA mandate via the Billwerk partner gateway. The X-Recaptcha-Token is relayed to CSC unverified (CSC is the sole verifier); the reCAPTCHA action is pinned server-side. Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the sepa_payment action.
 */
export const setSepaPayment = <ThrowOnError extends boolean = false>(
  options: Options<SetSepaPaymentData, ThrowOnError>,
): RequestResult<SetSepaPaymentResponses, SetSepaPaymentErrors, ThrowOnError> =>
  (options.client ?? client).post<SetSepaPaymentResponses, SetSepaPaymentErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetSepaPaymentResponse.parseAsync(data),
    url: '/api/v1/billing/payment/sepa',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Catalog data (display texts, logos, images) for a bookable, keyed by the productId/optionId from a subscription.
 */
export const getBookable = <ThrowOnError extends boolean = false>(
  options: Options<GetBookableData, ThrowOnError>,
): RequestResult<GetBookableResponses, GetBookableErrors, ThrowOnError> =>
  (options.client ?? client).get<GetBookableResponses, GetBookableErrors, ThrowOnError>({
    responseTransformer: getBookableResponseTransformer,
    responseValidator: async (data) => await zGetBookableResponse.parseAsync(data),
    url: '/api/v1/bookables/{id}',
    ...options,
  });

/**
 * Creates a package-configuration booking session.
 */
export const createBookingSession = <ThrowOnError extends boolean = false>(
  options: Options<CreateBookingSessionData, ThrowOnError>,
): RequestResult<CreateBookingSessionResponses, CreateBookingSessionErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateBookingSessionResponses, CreateBookingSessionErrors, ThrowOnError>({
    responseTransformer: createBookingSessionResponseTransformer,
    responseValidator: async (data) => await zCreateBookingSessionResponse.parseAsync(data),
    url: '/api/v1/booking/sessions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fetches an existing package-configuration booking session.
 */
export const getBookingSession = <ThrowOnError extends boolean = false>(
  options: Options<GetBookingSessionData, ThrowOnError>,
): RequestResult<GetBookingSessionResponses, GetBookingSessionErrors, ThrowOnError> =>
  (options.client ?? client).get<GetBookingSessionResponses, GetBookingSessionErrors, ThrowOnError>({
    responseTransformer: getBookingSessionResponseTransformer,
    responseValidator: async (data) => await zGetBookingSessionResponse.parseAsync(data),
    url: '/api/v1/booking/sessions/{id}',
    ...options,
  });

/**
 * Fetches the price summary of the product currently selected in a booking session.
 */
export const getBookingPriceSummary = <ThrowOnError extends boolean = false>(
  options: Options<GetBookingPriceSummaryData, ThrowOnError>,
): RequestResult<GetBookingPriceSummaryResponses, GetBookingPriceSummaryErrors, ThrowOnError> =>
  (options.client ?? client).get<GetBookingPriceSummaryResponses, GetBookingPriceSummaryErrors, ThrowOnError>({
    responseTransformer: getBookingPriceSummaryResponseTransformer,
    responseValidator: async (data) => await zGetBookingPriceSummaryResponse.parseAsync(data),
    url: '/api/v1/booking/sessions/{id}/price-summary',
    ...options,
  });

/**
 * Selects a different product in a package-configuration booking session.
 */
export const switchBookingProduct = <ThrowOnError extends boolean = false>(
  options: Options<SwitchBookingProductData, ThrowOnError>,
): RequestResult<SwitchBookingProductResponses, SwitchBookingProductErrors, ThrowOnError> =>
  (options.client ?? client).post<SwitchBookingProductResponses, SwitchBookingProductErrors, ThrowOnError>({
    responseValidator: async (data) => await zSwitchBookingProductResponse.parseAsync(data),
    url: '/api/v1/booking/sessions/{id}/switch-product',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Hand the customer's data to Funke and return their basket URL
 *
 * Requires a paid subscription. Every call creates a new basket upstream — there is no idempotency, so a retry is a second basket. Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the funke_redeem action.
 */
export const redeemFunkeOffer = <ThrowOnError extends boolean = false>(
  options: Options<RedeemFunkeOfferData, ThrowOnError>,
): RequestResult<RedeemFunkeOfferResponses, RedeemFunkeOfferErrors, ThrowOnError> =>
  (options.client ?? client).post<RedeemFunkeOfferResponses, RedeemFunkeOfferErrors, ThrowOnError>({
    responseValidator: async (data) => await zRedeemFunkeOfferResponse.parseAsync(data),
    url: '/api/v1/campaigns/funke/redeem',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the request_cancellation action.
 */
export const requestCancellation = <ThrowOnError extends boolean = false>(
  options: Options<RequestCancellationData, ThrowOnError>,
): RequestResult<RequestCancellationResponses, RequestCancellationErrors, ThrowOnError> =>
  (options.client ?? client).post<RequestCancellationResponses, RequestCancellationErrors, ThrowOnError>({
    responseValidator: async (data) => await zRequestCancellationResponse.parseAsync(data),
    url: '/api/v1/cancellation/request',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getCommunicationPreferences = <ThrowOnError extends boolean = false>(
  options?: Options<GetCommunicationPreferencesData, ThrowOnError>,
): RequestResult<GetCommunicationPreferencesResponses, GetCommunicationPreferencesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetCommunicationPreferencesResponses, GetCommunicationPreferencesErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetCommunicationPreferencesResponse.parseAsync(data),
    url: '/api/v1/communication-preferences',
    ...options,
  });

export const unsubscribeCommunicationPreferences = <ThrowOnError extends boolean = false>(
  options: Options<UnsubscribeCommunicationPreferencesData, ThrowOnError>,
): RequestResult<UnsubscribeCommunicationPreferencesResponses, UnsubscribeCommunicationPreferencesErrors, ThrowOnError> =>
  (options.client ?? client).put<UnsubscribeCommunicationPreferencesResponses, UnsubscribeCommunicationPreferencesErrors, ThrowOnError>({
    responseValidator: async (data) => await zUnsubscribeCommunicationPreferencesResponse.parseAsync(data),
    url: '/api/v1/communication-preferences/unsubscribe',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const updateCommunicationPreferences = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCommunicationPreferencesData, ThrowOnError>,
): RequestResult<UpdateCommunicationPreferencesResponses, UpdateCommunicationPreferencesErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateCommunicationPreferencesResponses, UpdateCommunicationPreferencesErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateCommunicationPreferencesResponse.parseAsync(data),
    url: '/api/v1/communication-preferences/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getDevices = <ThrowOnError extends boolean = false>(
  options?: Options<GetDevicesData, ThrowOnError>,
): RequestResult<GetDevicesResponses, GetDevicesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetDevicesResponses, GetDevicesErrors, ThrowOnError>({
    responseTransformer: getDevicesResponseTransformer,
    responseValidator: async (data) => await zGetDevicesResponse.parseAsync(data),
    url: '/api/v1/devices',
    ...options,
  });

export const removeAllDevices = <ThrowOnError extends boolean = false>(
  options?: Options<RemoveAllDevicesData, ThrowOnError>,
): RequestResult<RemoveAllDevicesResponses, RemoveAllDevicesErrors, ThrowOnError> =>
  (options?.client ?? client).delete<RemoveAllDevicesResponses, RemoveAllDevicesErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveAllDevicesResponse.parseAsync(data),
    url: '/api/v1/devices/remove-all',
    ...options,
  });

export const removeDevice = <ThrowOnError extends boolean = false>(
  options: Options<RemoveDeviceData, ThrowOnError>,
): RequestResult<RemoveDeviceResponses, RemoveDeviceErrors, ThrowOnError> =>
  (options.client ?? client).delete<RemoveDeviceResponses, RemoveDeviceErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveDeviceResponse.parseAsync(data),
    url: '/api/v1/devices/{device-id}/remove',
    ...options,
  });

/**
 * Check if email is available
 *
 * Returns whether the given email can be used to register a new account. If unavailable, takenBy indicates which provider/system owns it.
 */
export const emailCheck = <ThrowOnError extends boolean = false>(
  options: Options<EmailCheckData, ThrowOnError>,
): RequestResult<EmailCheckResponses, EmailCheckErrors, ThrowOnError> =>
  (options.client ?? client).get<EmailCheckResponses, EmailCheckErrors, ThrowOnError>({
    responseValidator: async (data) => await zEmailCheckResponse.parseAsync(data),
    url: '/api/v1/email-check',
    ...options,
  });

export const addFeedback = <ThrowOnError extends boolean = false>(
  options: Options<AddFeedbackData, ThrowOnError>,
): RequestResult<AddFeedbackResponses, AddFeedbackErrors, ThrowOnError> =>
  (options.client ?? client).post<AddFeedbackResponses, AddFeedbackErrors, ThrowOnError>({
    responseValidator: async (data) => await zAddFeedbackResponse.parseAsync(data),
    url: '/api/v1/feedback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get all hardware products
 */
export const getHardwareProducts = <ThrowOnError extends boolean = false>(
  options?: Options<GetHardwareProductsData, ThrowOnError>,
): RequestResult<GetHardwareProductsResponses, GetHardwareProductsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetHardwareProductsResponses, GetHardwareProductsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetHardwareProductsResponse.parseAsync(data),
    url: '/api/v1/hardware-products',
    ...options,
  });

/**
 * Current home-network (WLAN) registration status for the authenticated customer. 404 if no home network is set.
 */
export const getHomeZoneStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomeZoneStatusData, ThrowOnError>,
): RequestResult<GetHomeZoneStatusResponses, GetHomeZoneStatusErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetHomeZoneStatusResponses, GetHomeZoneStatusErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetHomeZoneStatusResponse.parseAsync(data),
    url: '/api/v1/home-zone',
    ...options,
  });

/**
 * streams a return-label PDF from the selected logistics provider
 */
export const getReturnLabel = <ThrowOnError extends boolean = false>(
  options: Options<GetReturnLabelData, ThrowOnError>,
): RequestResult<GetReturnLabelResponses, GetReturnLabelErrors, ThrowOnError> =>
  (options.client ?? client).get<GetReturnLabelResponses, GetReturnLabelErrors, ThrowOnError>({
    url: '/api/v1/logistics/{provider}/return-labels/{returnLabelId}',
    ...options,
  });

export const getOrderHistory = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrderHistoryData, ThrowOnError>,
): RequestResult<GetOrderHistoryResponses, GetOrderHistoryErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetOrderHistoryResponses, GetOrderHistoryErrors, ThrowOnError>({
    responseTransformer: getOrderHistoryResponseTransformer,
    responseValidator: async (data) => await zGetOrderHistoryResponse.parseAsync(data),
    url: '/api/v1/order-history',
    ...options,
  });

export const startItemReturn = <ThrowOnError extends boolean = false>(
  options: Options<StartItemReturnData, ThrowOnError>,
): RequestResult<StartItemReturnResponses, StartItemReturnErrors, ThrowOnError> =>
  (options.client ?? client).post<StartItemReturnResponses, StartItemReturnErrors, ThrowOnError>({
    responseValidator: async (data) => await zStartItemReturnResponse.parseAsync(data),
    url: '/api/v1/ordermanagement/start-item-return',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const listOrders = <ThrowOnError extends boolean = false>(
  options?: Options<ListOrdersData, ThrowOnError>,
): RequestResult<ListOrdersResponses, ListOrdersErrors, ThrowOnError> =>
  (options?.client ?? client).get<ListOrdersResponses, ListOrdersErrors, ThrowOnError>({
    responseTransformer: listOrdersResponseTransformer,
    responseValidator: async (data) => await zListOrdersResponse.parseAsync(data),
    url: '/api/v1/orders',
    ...options,
  });

/**
 * Current permission/consent status of the authenticated user.
 */
export const getPermissions = <ThrowOnError extends boolean = false>(
  options?: Options<GetPermissionsData, ThrowOnError>,
): RequestResult<GetPermissionsResponses, GetPermissionsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetPermissionsResponses, GetPermissionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetPermissionsResponse.parseAsync(data),
    url: '/api/v1/permissions',
    ...options,
  });

/**
 * pricebreakdown of the users subscription
 */
export const getPriceBreakdown = <ThrowOnError extends boolean = false>(
  options?: Options<GetPriceBreakdownData, ThrowOnError>,
): RequestResult<GetPriceBreakdownResponses, GetPriceBreakdownErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetPriceBreakdownResponses, GetPriceBreakdownErrors, ThrowOnError>({
    responseTransformer: getPriceBreakdownResponseTransformer,
    responseValidator: async (data) => await zGetPriceBreakdownResponse.parseAsync(data),
    url: '/api/v1/price-breakdown',
    ...options,
  });

/**
 * recording summary of the user
 */
export const getSummary = <ThrowOnError extends boolean = false>(
  options?: Options<GetSummaryData, ThrowOnError>,
): RequestResult<GetSummaryResponses, GetSummaryErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetSummaryResponses, GetSummaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetSummaryResponse.parseAsync(data),
    url: '/api/v1/recording/summary',
    ...options,
  });

/**
 * Register a new waipu.tv customer (email/password).
 *
 * Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the registration action.
 */
export const registrationRegister = <ThrowOnError extends boolean = false>(
  options: Options<RegistrationRegisterData, ThrowOnError>,
): RequestResult<RegistrationRegisterResponses, RegistrationRegisterErrors, ThrowOnError> =>
  (options.client ?? client).post<RegistrationRegisterResponses, RegistrationRegisterErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistrationRegisterResponse.parseAsync(data),
    url: '/api/v1/registration',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete a freshly registered profile (mrf fields) and record consent.
 */
export const completeRegistration = <ThrowOnError extends boolean = false>(
  options: Options<CompleteRegistrationData, ThrowOnError>,
): RequestResult<CompleteRegistrationResponses, CompleteRegistrationErrors, ThrowOnError> =>
  (options.client ?? client).post<CompleteRegistrationResponses, CompleteRegistrationErrors, ThrowOnError>({
    responseTransformer: completeRegistrationResponseTransformer,
    responseValidator: async (data) => await zCompleteRegistrationResponse.parseAsync(data),
    url: '/api/v1/registration/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Whether the client's location is eligible for registration (German region).
 */
export const registrationLocationEligibility = <ThrowOnError extends boolean = false>(
  options?: Options<RegistrationLocationEligibilityData, ThrowOnError>,
): RequestResult<RegistrationLocationEligibilityResponses, RegistrationLocationEligibilityErrors, ThrowOnError> =>
  (options?.client ?? client).get<RegistrationLocationEligibilityResponses, RegistrationLocationEligibilityErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistrationLocationEligibilityResponse.parseAsync(data),
    url: '/api/v1/registration/location-eligibility',
    ...options,
  });

export const getRecentlyWatched = <ThrowOnError extends boolean = false>(
  options?: Options<GetRecentlyWatchedData, ThrowOnError>,
): RequestResult<GetRecentlyWatchedResponses, GetRecentlyWatchedErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetRecentlyWatchedResponses, GetRecentlyWatchedErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetRecentlyWatchedResponse.parseAsync(data),
    url: '/api/v1/settings/recently-watched',
    ...options,
  });

export const updateRecentlyWatched = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRecentlyWatchedData, ThrowOnError>,
): RequestResult<UpdateRecentlyWatchedResponses, UpdateRecentlyWatchedErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateRecentlyWatchedResponses, UpdateRecentlyWatchedErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateRecentlyWatchedResponse.parseAsync(data),
    url: '/api/v1/settings/recently-watched',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * subscription of the user
 */
export const getSubscription = <ThrowOnError extends boolean = false>(
  options?: Options<GetSubscriptionData, ThrowOnError>,
): RequestResult<GetSubscriptionResponses, GetSubscriptionErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetSubscriptionResponses, GetSubscriptionErrors, ThrowOnError>({
    responseTransformer: getSubscriptionResponseTransformer,
    responseValidator: async (data) => await zGetSubscriptionResponse.parseAsync(data),
    url: '/api/v1/subscription',
    ...options,
  });

/**
 * capabilities of the users subscription
 */
export const getSubscriptionCapabilities = <ThrowOnError extends boolean = false>(
  options?: Options<GetSubscriptionCapabilitiesData, ThrowOnError>,
): RequestResult<GetSubscriptionCapabilitiesResponses, GetSubscriptionCapabilitiesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetSubscriptionCapabilitiesResponses, GetSubscriptionCapabilitiesErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetSubscriptionCapabilitiesResponse.parseAsync(data),
    url: '/api/v1/subscription/capabilities',
    ...options,
  });

export const getUser = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserData, ThrowOnError>,
): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({
    responseTransformer: getUserResponseTransformer,
    responseValidator: async (data) => await zGetUserResponse.parseAsync(data),
    url: '/api/v1/user',
    ...options,
  });

/**
 * Link a verified Sign in with Apple identity onto the authenticated account.
 */
export const linkAppleIdentity = <ThrowOnError extends boolean = false>(
  options: Options<LinkAppleIdentityData, ThrowOnError>,
): RequestResult<LinkAppleIdentityResponses, LinkAppleIdentityErrors, ThrowOnError> =>
  (options.client ?? client).post<LinkAppleIdentityResponses, LinkAppleIdentityErrors, ThrowOnError>({
    responseTransformer: linkAppleIdentityResponseTransformer,
    responseValidator: async (data) => await zLinkAppleIdentityResponse.parseAsync(data),
    url: '/api/v1/user/apple-link',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const changeEmail = <ThrowOnError extends boolean = false>(
  options: Options<ChangeEmailData, ThrowOnError>,
): RequestResult<ChangeEmailResponses, ChangeEmailErrors, ThrowOnError> =>
  (options.client ?? client).patch<ChangeEmailResponses, ChangeEmailErrors, ThrowOnError>({
    responseTransformer: changeEmailResponseTransformer,
    responseValidator: async (data) => await zChangeEmailResponse.parseAsync(data),
    url: '/api/v1/user/change-email',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const changePassword = <ThrowOnError extends boolean = false>(
  options: Options<ChangePasswordData, ThrowOnError>,
): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> =>
  (options.client ?? client).patch<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    responseValidator: async (data) => await zChangePasswordResponse.parseAsync(data),
    url: '/api/v1/user/change-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const resendEmailConfirmation = <ThrowOnError extends boolean = false>(
  options?: Options<ResendEmailConfirmationData, ThrowOnError>,
): RequestResult<ResendEmailConfirmationResponses, ResendEmailConfirmationErrors, ThrowOnError> =>
  (options?.client ?? client).post<ResendEmailConfirmationResponses, ResendEmailConfirmationErrors, ThrowOnError>({
    url: '/api/v1/user/resend-email-confirmation',
    ...options,
  });

export const updatePersonalData = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePersonalDataData, ThrowOnError>,
): RequestResult<UpdatePersonalDataResponses, UpdatePersonalDataErrors, ThrowOnError> =>
  (options.client ?? client).patch<UpdatePersonalDataResponses, UpdatePersonalDataErrors, ThrowOnError>({
    responseTransformer: updatePersonalDataResponseTransformer,
    responseValidator: async (data) => await zUpdatePersonalDataResponse.parseAsync(data),
    url: '/api/v1/user/update-personal-data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const verifyEmail = <ThrowOnError extends boolean = false>(
  options: Options<VerifyEmailData, ThrowOnError>,
): RequestResult<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError> =>
  (options.client ?? client).post<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError>({
    responseValidator: async (data) => await zVerifyEmailResponse.parseAsync(data),
    url: '/api/v1/user/verify-email',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Requires an X-Recaptcha-Token header carrying a reCAPTCHA v3 token minted for the request_withdrawal action.
 */
export const requestWithdrawal = <ThrowOnError extends boolean = false>(
  options: Options<RequestWithdrawalData, ThrowOnError>,
): RequestResult<RequestWithdrawalResponses, RequestWithdrawalErrors, ThrowOnError> =>
  (options.client ?? client).post<RequestWithdrawalResponses, RequestWithdrawalErrors, ThrowOnError>({
    responseValidator: async (data) => await zRequestWithdrawalResponse.parseAsync(data),
    url: '/api/v1/withdrawal',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
